<template>
  <div>
    <div>
      {{ $t('label_administration_selectTagsDescription') }}
    </div>
    <b-form-group
      horizontal
      breakpoint="lg"
      label-size="lg"
      label-class="break-label"
    >
      <div>
        {{ $t("label_administration_wizard_createNewTags") }}
      </div>
      <div>
        <div
          v-if="getTagsToCreate.length"
          style="
            margin-top: 25px;
            margin-bottom: 25px;
          "
        >
          <tag-to-create :tag-to-create="getTagsToCreate[0]" :tag-index="0" />
        </div>
      </div>
      <div>
        {{ $t("label_administration_wizard_createNewTags_tagsAreAutomaticallyAdded") }}
      </div>
    </b-form-group>
    <b-form-group
      horizontal
      breakpoint="lg"
      label-size="lg"
      label-class="break-label"
    >
      <b-checkbox
        :checked="getShouldSelectTags"
        @change.native="setShouldSelectTags"
      >
        {{ $t("label_administration_wizard_createNewTags_selectTagForGroup") }}
      </b-checkbox>
      <template v-if="getShouldSelectTags">
      <b-row v-if=" !getUseExistingTags && getTagsToCreate.length < 2"               style="margin-top: 25px; margin-bottom: 25px">
        <b-col cols="5">
          <b-button
            variant="primary"
            @click="useExisting()"
            style="width: 100%"
        >
          {{ $t("label_administration_wizard_createNewTags_useExistingTag") }}
        </b-button>
        </b-col>
        <b-col cols="2" style="text-align: center">{{ $t("label_administration_wizard_createNewTags_or") }}</b-col>
        <b-col cols="5">
      <b-button
        variant="primary"
        @click="addTagToCreate()"
        style="width: 100%"
      >
        {{ $t("label_administration_wizard_createNewTags_addNewTag") }}
      </b-button>
        </b-col>
      </b-row>
      <!--use existing -->
        <indica-check-box
        v-if="getUseExistingTags"
        table-name="Tags"
        :save-to-store="true"
        :filter-by-field="filterByTags.field"
        :filter-by-value="filterByTags.value"
        store-name="tags"
        :show-search="true"
        ref="tagsSelector"
      />
      <b-row v-if="getUseExistingTags">
        <b-col cols="5">
        </b-col>
        <b-col cols="2" style="text-align: center">{{ $t("label_administration_wizard_createNewTags_or") }}</b-col>
        <b-col cols="5">
          <b-button
            style="width: 100%"
            variant="primary"
            @click="addTagToCreate()"
          >
            {{ $t("label_administration_wizard_createNewTags_addNewTag") }}
          </b-button>
        </b-col>
      </b-row>

        <!--create a new tag-->

        <div
          v-if="getTagsToCreate.length > 1"
          style="

            margin-top: 25px;
            margin-bottom: 25px;
          "
        >
          <tag-to-create :tag-to-create="getTagsToCreate[1]" :tag-index="1" />
        </div>
        <b-row v-if="getTagsToCreate.length > 1">
          <b-col cols="5">
          </b-col>
          <b-col cols="2" style="text-align: center">{{ $t("label_administration_wizard_createNewTags_or") }}</b-col>
          <b-col cols="5">
            <b-button
              style="width: 100%"
              variant="primary"
              @click="useExisting()"
            >
              {{ $t("label_administration_wizard_createNewTags_useExistingTag") }}
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-form-group>
    <b-form-group>
      {{ $t("label_administration_wizard_createNewTags_defaultTags") }}
      <div v-for="(tag, tagIndex) in getDefaultTags" :key="tagIndex">
        {{ tag.name }}
      </div>
    </b-form-group>
  </div>
</template>
<script>
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { mapGetters } from "vuex";
import TagToCreate from "@/components/modules/administration/businessCreation/tabs/TagToCreate";
import IndicaCheckBox from "@/utils/forms/indica-check-box";

export default {
  name: "TagsTab",
  components: {
    TagToCreate,
    IndicaCheckBox
  },
  data() {
    return {
      filterByTags: { field: "category", value: "multiple" }
    };
  },
  watch: {
    getShouldSelectTags:async function (){
      if(!this.getShouldSelectTags){
        await this.deleteNewTags()
        await     this.$store.dispatch('setUseExistingTags',false)

      }
    }
  },
  methods: {
   async deleteNewTags(){
      let totalTagsToCreate = this.getTagsToCreate.length
      if(totalTagsToCreate > 1){
        for (let index = 1; index<totalTagsToCreate; index++){
          await this.$store.dispatch("removeTagToCreate", 1);
        }
      }
    },
    setShouldSelectTags(event) {
      this.$store.dispatch("setShouldSelectTags", event.target.checked);
    },
    async addTagToCreate() {
      if( this.$refs.tagsSelector) {
        this.$refs.tagsSelector.clearStorageAndRefresh()
      }
      await this.$store.dispatch("addTagToCreate", { tag: {category: 'multiple'}, index: -1 });
      await     this.$store.dispatch('setUseExistingTags',false)
    },
   async useExisting(){
    await this.deleteNewTags()
    await     this.$store.dispatch('setUseExistingTags',true)
    }
  },
  computed: {
    ...mapGetters([
      "getTagsToCreate",
      "getAllStoreInfo",
      "getShouldSelectTags",
      "getDefaultTags",
      "getUseExistingTags"
    ]),
  },
};
</script>

<style lang="scss" scoped>
.new-id {
  font-size: 11px;
  color: gray;
}

.error {
  color: red;
}

.ok {
  color: green;
}

.message-error {
  font-size: 16px;
  color: red;
  text-align: center;
  padding: 30px;
}

.delete-tab {
  color: red;
  font-weight: bold;
  margin-left: 5px;
  padding: 2px 5px;
  font-size: 15px;
  transition: 0.3s;

  &:hover {
    font-size: 13px;
  }
}
</style>
